import { alpha,Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import AppStore from "~/images/AppStore.png";
import PlayStore from "~/images/GooglePlay.png";

export const FooterStores: React.FC<{ className?: string }> = ({
  className,
}) => {
  const theme = useTheme();

  return (
    <Box
      mt={2}
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      className={className}
    >
      <Typography
        variant="subtitle1"
        fontWeight={700}
        color="primary"
        sx={{
          letterSpacing: "0.02em",
          mb: 1,
          textAlign: "center",
          textTransform: "uppercase",
          fontSize: { xs: "1rem", sm: "1.1rem" },
        }}
      >
        <FormattedMessage
          defaultMessage="Get the VPG App"
          id="nCDsyy"
        />
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          mb: 2,
          textAlign: "center",
          fontWeight: 400,
          fontSize: { xs: "0.95rem", sm: "1rem" },
          display: { xs: "block", sm: "none" },
        }}
      >
        <FormattedMessage
          defaultMessage="Download our app for the best VPG experience on mobile."
          id="XU6YmB"
        />
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        gap={2}
        alignItems="center"
        justifyContent="center"
      >
        <Link
          to={{
            pathname:
              "https://play.google.com/store/apps/details?id=com.virtualprogaming&hl=en&gl=US",
          }}
          target="_blank"
          style={{ display: "block" }}
        >
          <Box
            component="img"
            src={PlayStore}
            alt="Google Play Store"
            sx={{
              height: 44,
              width: "auto",
              borderRadius: 2,
              boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.1)}`,
              transition: "transform 0.18s, box-shadow 0.18s",
              "&:hover": {
                transform: "translateY(-2px) scale(1.04)",
                boxShadow: `0 4px 16px ${alpha(
                  theme.palette.primary.main,
                  0.18
                )}`,
              },
            }}
          />
        </Link>
        <Link
          to={{
            pathname:
              "https://apps.apple.com/us/app/virtual-pro-gaming/id1477998568",
          }}
          target="_blank"
          style={{ display: "block" }}
        >
          <Box
            component="img"
            src={AppStore}
            alt="App Store"
            sx={{
              height: 44,
              width: "auto",
              borderRadius: 2,
              boxShadow: `0 2px 8px ${alpha(
                theme.palette.secondary.main,
                0.1
              )}`,
              transition: "transform 0.18s, box-shadow 0.18s",
              "&:hover": {
                transform: "translateY(-2px) scale(1.04)",
                boxShadow: `0 4px 16px ${alpha(
                  theme.palette.secondary.main,
                  0.18
                )}`,
              },
            }}
          />
        </Link>
      </Box>
    </Box>
  );
};
